"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
var katal_logger_1 = __importDefault(require("@amzn/katal-logger"));
var ua_parser_js_1 = require("ua-parser-js");
var atoz_shiftapp_initializer_1 = require("@amzn/atoz-shiftapp-initializer");
var emf_1 = require("../emf");
var consts_1 = require("../consts");
var handleLoggerErrors_1 = require("./handleLoggerErrors");
var rootElementDataSet = (_a = document === null || document === void 0 ? void 0 : document.getElementById('atoz-shift-management-page-root')) === null || _a === void 0 ? void 0 : _a.dataset;
var employeeId = (rootElementDataSet === null || rootElementDataSet === void 0 ? void 0 : rootElementDataSet.employeeId) || '';
var defaultLogConfig = {
    url: '{{KatalLoggerUrl}}',
    logToConsole: process.env.NODE_ENV !== 'production',
    // These values are added to every log by default
    context: {
        'x-atoz-client-request-id': atoz_shiftapp_initializer_1.ATOZ_ClIENT_REQUEST_ID,
        'x-atoz-employee-id': employeeId,
        // TODO: employeeId should be removed once it is safe to do so. We will be using x-atoz-employee-id to maintain consistency across our apps
        employeeId: employeeId,
        path: (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.href,
        deviceDetails: new ua_parser_js_1.UAParser().getResult()
    }
};
/**
 * Class that extends the KatalLogger with additional methods
 */
var ShiftManagementLogger = /** @class */ (function (_super) {
    __extends(ShiftManagementLogger, _super);
    function ShiftManagementLogger(config) {
        var _this = _super.call(this, config) || this;
        /**
         * Reports individual web vital metrics in the EMF format
         */
        _this.reportWebVital = function (_a) {
            var metricName = _a.name, metricValue = _a.value;
            _this.logEmfMetric({
                metricName: metricName,
                metricValue: metricValue,
                metricUnit: metricName !== 'CLS'
                    ? consts_1.METRIC_UNIT.MILLISECONDS
                    : consts_1.METRIC_UNIT.NONE
            });
        };
        /**
         * Passes a callback to all web vital reporters to log the metrics
         */
        _this.reportWebVitals = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, getCLS, getFID, getFCP, getLCP, getTTFB;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('web-vitals')); })];
                    case 1:
                        _a = _b.sent(), getCLS = _a.getCLS, getFID = _a.getFID, getFCP = _a.getFCP, getLCP = _a.getLCP, getTTFB = _a.getTTFB;
                        getCLS(this.reportWebVital);
                        getFID(this.reportWebVital);
                        getFCP(this.reportWebVital);
                        getLCP(this.reportWebVital);
                        getTTFB(this.reportWebVital);
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Emits an EMF formatted metric to CloudWatch using KatalLogger
         */
        _this.logEmfMetric = function (metricPayload) {
            var emfLog = (0, emf_1.formatEmfMetric)(metricPayload);
            _this.info(metricPayload.metricName, { emfLog: emfLog });
        };
        /**
         * Logs a count metric in the EMF format. The metric value is always 1
         */
        _this.emitCountMetric = function (_a) {
            var metricName = _a.metricName, dimensions = _a.dimensions;
            _this.logEmfMetric({
                metricName: metricName,
                metricValue: 1,
                metricUnit: consts_1.METRIC_UNIT.COUNT,
                dimensions: dimensions,
                context: defaultLogConfig.context
            });
        };
        /**
         * Logs a latency metric in milliseconds in the EMF format
         */
        _this.emitLatencyMetric = function (_a) {
            var metricName = _a.metricName, metricValue = _a.metricValue, dimensions = _a.dimensions;
            _this.logEmfMetric({
                metricName: metricName,
                metricValue: metricValue,
                metricUnit: consts_1.METRIC_UNIT.MILLISECONDS,
                dimensions: dimensions,
                context: defaultLogConfig.context
            });
        };
        /**
         * Logs a count metric and stacktrace for errors
         */
        _this.emitError = function (message, options) {
            if (options === void 0) { options = {}; }
            var context = options.context, dimensions = options.dimensions, error = options.error;
            var logContext = __assign(__assign(__assign({}, context), dimensions), { isCaught: true, errorContext: consts_1.ERROR_CONTEXT.APPLICATION });
            // Emit count metric for caught error
            _this.emitCountMetric({
                metricName: consts_1.METRIC_NAME.APP_ERROR_CAUGHT,
                dimensions: dimensions
            });
            // Log error with proper context
            if (error) {
                _this.error(message, error, logContext);
            }
            else {
                _this.error(message, logContext);
            }
        };
        /**
         * Logs a count metric and stacktrace for warnings
         */
        _this.emitWarn = function (message, options) {
            if (options === void 0) { options = {}; }
            var context = options.context, dimensions = options.dimensions, error = options.error;
            var logContext = __assign(__assign(__assign({}, context), dimensions), { isCaught: true, errorContext: consts_1.ERROR_CONTEXT.APPLICATION });
            // Emit count metric for caught warning
            _this.emitCountMetric({
                metricName: consts_1.METRIC_NAME.APP_WARN_CAUGHT,
                dimensions: dimensions
            });
            // Log warning with proper context
            if (error) {
                _this.warn(message, error, logContext);
            }
            else {
                _this.warn(message, logContext);
            }
        };
        _this.emitBIEvent = function () {
            /*
                In web, we use adobe omniture to collect bi events. We don't need to log by
                ourselves.
            */
        };
        return _this;
    }
    return ShiftManagementLogger;
}(katal_logger_1.default));
/**
 * Exposes the extended KatalLogger
 */
exports.logger = new ShiftManagementLogger(defaultLogConfig);
/**
 * Global Katal error listener
 * See https://katal.amazon.dev/for-developers/metrics/logger
 */
exports.logger.addErrorListener(handleLoggerErrors_1.handleLoggerErrors);
